import { types } from 'mobx-state-tree';
import { createContext, useContext } from 'react';
import { Client } from 'urql';

import { GlobalVariables } from 'stores/env';
import { createOnboardingStore, OnboardingStore } from 'stores/onboardingStore';
import { createOrgStore, OrgStore } from 'stores/orgStore';
import { createPageStore, PageStore } from 'stores/pageStore';
import { createUserStore, UserStore } from 'stores/userStore';

const RootStore = types.model('RootStore', {
  orgStore: OrgStore,
  userStore: UserStore,
  pageStore: PageStore,
  onboardingStore: OnboardingStore,
});

export const createRootStore = (urqlClient: Client) => {
  const orgStore = createOrgStore();
  const userStore = createUserStore();
  const pageStore = createPageStore();
  const onboardingStore = createOnboardingStore();
  const env: GlobalVariables = { urqlClient };
  return RootStore.create({ orgStore, userStore, pageStore, onboardingStore }, env);
};

type TRootStore = ReturnType<typeof createRootStore>;
const RootStoreContext = createContext<TRootStore>({} as TRootStore);

export const RootStoreProvider = RootStoreContext.Provider;
export const useStores = () => useContext(RootStoreContext);
export const usePageStore = () => useStores().pageStore;
export const useOrgStore = () => useStores().orgStore;
export const useUserStore = () => useStores().userStore;
export const useOnboardingStore = () => useStores().onboardingStore;
